<template>
  <div class="dwp-relative dwp-inline-block dwp-text-left">
    <div class="dwp-cursor-pointer dwp-select-none">
      <slot />
    </div>

    <!--
    Dropdown panel, show/hide based on dropdown state.

    Entering: "transition ease-out duration-100"
      From: "transform opacity-0 scale-95"
      To: "transform opacity-100 scale-100"
    Leaving: "transition ease-in duration-75"
      From: "transform opacity-100 scale-100"
      To: "transform opacity-0 scale-95"
    -->
    <transition
      enter-active-class="dwp-transition dwp-ease-out dwp-duration-100"
      enter-class="dwp-transform dwp-opacity-0 dwp-scale-95"
      enter-to-class="dwp-transform dwp-opacity-100 dwp-scale-100"
      leave-active-class="dwp-transition dwp-ease-in dwp-duration-75"
      leave-class="dwp-transform dwp-opacity-100 dwp-scale-100"
      leave-to-class="dwp-transform dwp-opacity-0 dwp-scale-95"
    >
      <div
        v-if="isOpen && $slots.list"
        class="dwp-absolute dwp-mt-2 dwp-rounded-md dwp-shadow-lg dwp-z-40"
        :class="[positionClass,widthClass]"
      >
        <div class="dwp-rounded-sm dwp-bg-white dwp-shadow-xs">
          <slot name="list" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    open: Boolean,
    position: String,
    widthClass: {
      type: String,
      default: "dwp-w-40"
    }
  },

  mounted() {
    jQuery(this.$el)
      .closest("body")
      .on("click touchstart", this.outsideClick);
  },

  beforeDestroy() {
    jQuery(this.$el)
      .closest("body")
      .off("click touchstart", this.outsideClick);
  },

  computed: {
    isOpen: {
      get() {
        return this.open;
      },
      set(val) {
        this.$emit("update:open", val);
      }
    },
    positionClass() {
      switch (this.position) {
        case "right":
          return "dwp-origin-top-right dwp-right-0";
          break;
        case "left":
          return "dwp-origin-top-left dwp-left-0";
          break;
        default:
          return "dwp-origin-top dwp-left-0";
          break;
      }
    }
  },
  methods: {
    outsideClick(e) {
      e.stopPropagation();
      if (this.$el.contains(e.target)) {
        return;
      }
      this.isOpen = false;
    }
  }
};
</script>